var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_150_179)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 25,
    r: 25,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2159 11.5C25.7294 11.5 25.2526 11.6352 24.8385 11.8904C24.4244 12.1457 24.0894 12.5109 23.8709 12.9455L22.8384 15H19.8809C18.7205 15 17.6077 15.4609 16.7873 16.2814C15.9668 17.1019 15.5059 18.2147 15.5059 19.375V33.375C15.5059 34.5353 15.9668 35.6481 16.7873 36.4686C17.6077 37.2891 18.7205 37.75 19.8809 37.75H26.0059C26.0199 37.5505 26.0514 37.3475 26.1021 37.1427L26.7584 34.5212C26.9614 33.7092 27.3446 32.9533 27.8766 32.311C26.2125 31.9088 24.7533 30.9111 23.7748 29.5062C22.7963 28.1014 22.3663 26.3868 22.5661 24.6864C22.7658 22.9861 23.5814 21.4178 24.8588 20.278C26.1362 19.1381 27.7868 18.5056 29.4989 18.5C31.0682 18.5002 32.5919 19.0275 33.8258 19.9973C35.0596 20.9671 35.9319 22.3232 36.3029 23.848L36.6809 23.4717C37.5765 22.5763 38.7773 22.0522 40.0429 22.0045C41.3085 21.9568 42.5454 22.389 43.5059 23.2145V19.3733C43.5059 18.2129 43.0449 17.1001 42.2245 16.2797C41.404 15.4592 40.2912 14.9983 39.1309 14.9983H36.1751L35.1514 12.9508C34.9333 12.5147 34.598 12.148 34.1832 11.8917C33.7684 11.6355 33.2904 11.4999 32.8029 11.5H26.2159ZM34.7506 25.4037C34.7319 24.3738 34.4106 23.372 33.8267 22.5234C33.2427 21.6747 32.4221 21.0165 31.4668 20.6309C30.5116 20.2452 29.464 20.1492 28.4545 20.3546C27.445 20.56 26.5183 21.0579 25.7898 21.7862C25.0612 22.5145 24.563 23.4411 24.3573 24.4505C24.1515 25.4599 24.2472 26.5075 24.6326 27.4629C25.0179 28.4183 25.6758 29.2392 26.5243 29.8234C27.3728 30.4075 28.3744 30.7292 29.4044 30.7482L34.7506 25.4037ZM37.9181 24.709L29.4656 33.1615C28.9736 33.6541 28.6246 34.2711 28.4559 34.9465L27.7996 37.568C27.7349 37.8287 27.7387 38.1018 27.8107 38.3606C27.8827 38.6194 28.0204 38.8552 28.2104 39.0451C28.4005 39.2349 28.6364 39.3724 28.8953 39.4442C29.1542 39.5159 29.4272 39.5195 29.6879 39.4545L32.3094 38.8C32.9851 38.631 33.6021 38.2813 34.0944 37.7885L42.5469 29.336C43.1526 28.7206 43.4905 27.8907 43.487 27.0271C43.4835 26.1636 43.1389 25.3365 42.5281 24.726C41.9174 24.1155 41.0901 23.7711 40.2266 23.7679C39.3631 23.7648 38.5333 24.103 37.9181 24.709Z",
    fill: "#7A03FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_150_179",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_150_179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_150_179",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/imageUploadIcon.766934489cf48d9e6e43bf39f27ceace.svg";
export { ForwardRef as ReactComponent };